import { ABCClass, XYZClass } from '@slot-matrix/shared-types';
const SEGMENTS = [
    { abc: ABCClass.A, xyz: XYZClass.X, label: 'AX' },
    { abc: ABCClass.A, xyz: XYZClass.Y, label: 'AY' },
    { abc: ABCClass.A, xyz: XYZClass.Z, label: 'AZ' },
    { abc: ABCClass.B, xyz: XYZClass.X, label: 'BX' },
    { abc: ABCClass.B, xyz: XYZClass.Y, label: 'BY' },
    { abc: ABCClass.B, xyz: XYZClass.Z, label: 'BZ' },
    { abc: ABCClass.C, xyz: XYZClass.X, label: 'CX' },
    { abc: ABCClass.C, xyz: XYZClass.Y, label: 'CY' },
    { abc: ABCClass.C, xyz: XYZClass.Z, label: 'CZ' },
];
/**
 * Build the 9-cell ABC/XYZ matrix from classification results.
 * Always returns all 9 cells, even if some are empty.
 */
export function buildMatrix(classifications, _abcResults, _xyzResults) {
    const totalSkus = classifications.length;
    // Initialize all 9 cells
    const cellMap = new Map();
    for (const seg of SEGMENTS) {
        cellMap.set(seg.label, { skuCount: 0, totalMetricValue: 0, totalCv: 0, totalPickFreq: 0 });
    }
    // Populate cells
    for (const cls of classifications) {
        const seg = cls.segment;
        const cell = cellMap.get(seg);
        if (cell) {
            cell.skuCount++;
            cell.totalMetricValue += cls.abc.metricValue;
            cell.totalCv += cls.xyz.cv;
            cell.totalPickFreq += cls.abc.metricValue; // Using metric value as proxy for pick frequency
        }
    }
    // Build result
    return SEGMENTS.map((seg) => {
        const cell = cellMap.get(seg.label);
        return {
            segment: seg.label,
            abcClass: seg.abc,
            xyzClass: seg.xyz,
            skuCount: cell.skuCount,
            percentOfTotal: totalSkus > 0 ? (cell.skuCount / totalSkus) * 100 : 0,
            totalMetricValue: cell.totalMetricValue,
            avgCv: cell.skuCount > 0 ? cell.totalCv / cell.skuCount : 0,
            avgPickFrequency: cell.skuCount > 0 ? cell.totalPickFreq / cell.skuCount : 0,
        };
    });
}
//# sourceMappingURL=matrixBuilder.js.map